import axios from 'axios'

import {
  TApiPricingResponse,
  TFranchiseResponse,
  TInvoiceConfigResponse,
  TStarResponse,
} from '../../../coreGlobal/models/franchise/franchise'

// Painel da franquia só visualiza; o cadastro e a edição ficam no admin (pages/adminFranchises)
const API_URL = process.env.REACT_APP_API_URL + '/api'
const FRANCHISE_URL = `${API_URL}/franchises`

const getFranchiseById = (id: string): Promise<TFranchiseResponse> => {
  return axios
    .get(`${FRANCHISE_URL}/${id}?include=machines`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getStarsById = (id: string): Promise<TStarResponse> => {
  return axios
    .get(`${FRANCHISE_URL}/${id}/stars`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getInvoiceConfigId = (id: string): Promise<TInvoiceConfigResponse> => {
  return axios
    .get(`${FRANCHISE_URL}/${id}/invoice-config`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getApiPricingId = (id: string): Promise<TApiPricingResponse> => {
  return axios
    .get(`${FRANCHISE_URL}/${id}/api-pricing`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

export {getFranchiseById, getStarsById, getInvoiceConfigId, getApiPricingId}
